var map = {
	"./bug.svg": "6a35",
	"./dark.svg": "bec4",
	"./dragon.svg": "57e7",
	"./electric.svg": "da6f",
	"./fairy.svg": "c4a0",
	"./fighting.svg": "22a5",
	"./fire.svg": "1d5b",
	"./flying.svg": "7d26",
	"./ghost.svg": "816d",
	"./grass.svg": "603d",
	"./ground.svg": "f009",
	"./ice.svg": "eaf8",
	"./normal.svg": "c191",
	"./poison.svg": "216b",
	"./psychic.svg": "bb18",
	"./rock.svg": "0389",
	"./steel.svg": "822a",
	"./water.svg": "2d17"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "96a1";